import PixagriApplication from '../../models/PixagriApplications';
import { BaseApiService } from './BaseApiService';

export class BaseOrchestratorApiService extends BaseApiService {
  getApplication(): PixagriApplication {
    return PixagriApplication.PROCESSING_ORCHESTRATOR_API;
  }

}
